import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import utils from './utils/utils'
import appUtils from './utils/appUtils'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
import './assets/css/style.css'
import './assets/css/common.css'

Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$appUtils = appUtils
Vue.prototype.$layer = layer(Vue)


Raven.config('https://67c5e34e1f9f4885bf00d8de78f85a68@error.jiankanghao.net/37').addPlugin(RavenVue, Vue).install();



new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
